import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import HomeIcon from "@mui/icons-material/Home";
import BarChartIcon from "@mui/icons-material/BarChart";
import { useNavigate } from "react-router-dom";
import ProfileDropDown from "./ProfileDropDown";

export default function UtilityNavbar() {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const nav = (path) => { navigate(path); setIsDrawerOpen(false); };

  const navItems = [
    { label: "Home", icon: <HomeIcon />,     onClick: () => nav("/utility/") },
    { label: "M&V",  icon: <BarChartIcon />, onClick: () => nav("/utility/mv") },
  ];

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: "#161B22",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          zIndex: 1400,
        }}
      >
        <Toolbar sx={{ gap: "4px" }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => setIsDrawerOpen((prev) => !prev)}
            sx={{ mr: "4px" }}
          >
            {isDrawerOpen ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>

          {/* Tjommie logo */}
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => nav("/utility/")}
          >
            <img src="/assets/tjommie-logo.svg" height="24" alt="Tjommie" style={{ display: "block" }} />
          </Box>

          {/* Vertical separator */}
          <Box sx={{ width: "1px", height: "18px", backgroundColor: "rgba(255,255,255,0.15)", mx: "12px", flexShrink: 0 }} />

          {/* App label */}
          <Typography sx={{ color: "rgba(255,255,255,0.5)", fontSize: "0.88rem", fontWeight: 400, flexGrow: 1 }}>
            DSM Utility
          </Typography>

          <ProfileDropDown />
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        anchor="left"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        PaperProps={{
          sx: {
            backgroundColor: "#161B22",
            borderRight: "1px solid rgba(255,255,255,0.08)",
          },
        }}
      >
        <List sx={{ width: 260, mt: 10 }}>
          {navItems.map(({ label, icon, onClick }) => (
            <ListItem
              key={label}
              button
              onClick={onClick}
              sx={{
                mt: 1,
                borderRadius: "8px",
                mx: "8px",
                width: "auto",
                "&:hover": { bgcolor: "rgba(255,255,255,0.05)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36, color: "rgba(255,255,255,0.55)" }}>
                {icon}
              </ListItemIcon>
              <ListItemText
                primary={label}
                primaryTypographyProps={{ sx: { color: "#fff", fontSize: "0.9rem" } }}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}
